import{classAdderBuilder as s}from"../../common/dist/classadder/classAdderBuilder.js";s({class:"mdc-deprecated-list-item__meta",tag:"span"});
//# sourceMappingURL=Meta.js.map
